import { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import { Operator } from '../../../types';
import OperatorSelect from '../../admin/forms/OperatorSelect';

interface LinkToOperatorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (operator: Operator) => void;
}

const LinkToOperatorDialog = (props: LinkToOperatorDialogProps) => {
  const { isOpen, onClose, onConfirm } = props;

  const [operator, setOperator] = useState<Operator | null>(null);

  const selectOperator = (operator: Operator | null) => {
    setOperator(operator);
  };

  const handleConfirm = () => {
    if (!operator) {
      return;
    }

    onConfirm(operator);
  };

  return (
    <Dialog
      maxWidth="sm"
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Koppel een exploitant</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ width: '520px' }}
        >
          <OperatorSelect onSelect={selectOperator} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Annuleren
        </Button>
        <Button onClick={handleConfirm} color="secondary" disabled={!operator}>
          Koppelen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkToOperatorDialog;
